import img1 from "../../../Assets/Home/vdo1.png";
import FeaturesVideo from "./FeaturesVideo";

export default function MixMastersFeatures() {
  const features = [
    {
      id: 1,
      title: "Reliability",
      description: "Guaranteed on-time delivery with consistent quality.",
    },
    {
      id: 2,
      title: "Bespoke Enchantments",
      description:
        "Custom concrete mixes designed to meet your specific project needs.",
    },
    {
      id: 3,
      title: "A Glimmer Of Sustainability",
      description:
        "Eco-friendly production with advanced waste reduction techniques.",
    },
    {
      id: 4,
      title: "Experience",
      description:
        "With a wealth of over 12 years of experience, we stand as your esteemed ally in the realm of ready-mix concrete.",
    },
  ];

  const IconBadge = ({ id, highlight }) => {
    const iconColor = highlight ? "white" : "#c020d0";

    const renderIcon = () => {
      switch (id) {
        case 1: // Reliability (Shield filled)
          return (
            <svg width="24" height="24" fill={iconColor}>
              <path d="M12 2l7 4v6c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6l7-4z" />
            </svg>
          );

        case 2: // Custom (Plus filled)
          return (
            <svg width="24" height="24" fill={iconColor}>
              <rect x="10" y="4" width="4" height="16" rx="1" />
              <rect x="4" y="10" width="16" height="4" rx="1" />
            </svg>
          );

        case 3: // Sustainability (Leaf filled)
          return (
            <svg width="24" height="24" fill={iconColor}>
              <path d="M4 14c4-8 12-8 16 0-4 6-12 6-16 0z" />
            </svg>
          );

        case 4: // Experience (User filled)
          return (
            <svg width="24" height="24" fill={iconColor}>
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c2-4 14-4 16 0" />
            </svg>
          );

        default:
          return null;
      }
    };

    return (
      <div
        className="w-12 h-12 flex-shrink-0 rounded-xl flex items-center justify-center"
        style={{
          background: highlight
            ? "linear-gradient(135deg, #e040fb, #c020d0)"
            : "linear-gradient(135deg, #f3e8ff, #ede0fa)",
        }}
      >
        {renderIcon()}
      </div>
    );
  };

  return (
    <div className="w-full bg-white md:py-10 py-6">
      <style>{`
        .feature-card { transition: transform 0.2s ease, box-shadow 0.2s ease; }
        .feature-card:hover { transform: translateY(-3px); box-shadow: 0 8px 28px rgba(192,32,208,0.12) !important; }
      `}</style>

      <div className="features-section px-4 md:px-8 lg:px-10">
        {/* Label */}
        <div className="text-center mb-3" data-aos="fade-up">
          <span
            className="text-xs font-semibold tracking-widest uppercase"
            style={{ color: "#c020d0", letterSpacing: "0.2em" }}
          >
            [FEATURES]
          </span>
        </div>

        {/* Heading */}
        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading leading-relaxed mb-8 lg:mb-12 "
        >
          Why Choose Us
        </h2>

        <div className="flex flex-col lg:flex-row gap-5 items-stretch">
          {/* Feature cards */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f, i) => (
              <div
                key={f.id}
                data-aos="fade-up"
                data-aos-delay={i * 120}
                className="feature-card border flex gap-4 hover:bg-[#fdf0ff] border-[#ebebeb] hover:border-[#e8b0f8] bg-[#f7f7f9] rounded-lg p-5 sm:p-5 "
              >
                <IconBadge id={f.id} highlight={f.highlight} />

                <div className="flex flex-col">
                  <h3
                    className="font-bold text-gray-900 mb-2 text-sm"
                    style={{ fontSize: "0.95rem", lineHeight: "1.3" }}
                  >
                    {f.title}
                  </h3>

                  <p className="text-gray-500 text-xs leading-relaxed">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Video card */}
          <FeaturesVideo />
          {/* <div
            data-aos="fade-left"
            className="relative rounded-2xl overflow-hidden cursor-pointer w-full lg:flex-shrink-0 lg:w-[500px]"
            style={{
              minHeight: "280px",
              background:
                "linear-gradient(160deg, #c8e0b0 0%, #d4e8b8 40%, #e0e8c8 100%)",
            }}
          >
            <img
              src={img1}
              alt="video thumbnail"
              className="absolute inset-0 w-full h-full object-cover"
            />

            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center"
                style={{
                  background: "rgba(255,255,255,0.92)",
                  boxShadow: "0 6px 24px rgba(0,0,0,0.25)",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.1)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 30px rgba(192,32,208,0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 24px rgba(0,0,0,0.25)";
                }}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderTop: "8px solid transparent",
                    borderBottom: "8px solid transparent",
                    borderLeft: "14px solid #1a1f3a",
                    marginLeft: "3px",
                  }}
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
